import {combineReducers} from 'redux';
import dateRangeReducer from './reducer-dateRange';
import filteredSampleIDReducer from './reducer-filteredSampleID';
import filteredEntryIDReducer from './reducer-filteredEntryID';
import clickedElementReducer from './reducer-clickedElement';
import transLinkReducer from './reducer-transLink';
import activeChartReducer from './reducer-activeChart';
import metadataReducer from './reducer-metadataReducer';
import floorplanReducer from './reducer-floorplanReducer';
import floorplanLevelReducer from './reducer-floorplanLevelReducer';
import treeReducer from './reducer-treeReducer';
import transmissionReducer from './reducer-transmissionReducer';
import layoutReducer from './reducer-layoutReducer';
import treeZoomLevelReducer from './reducer-treeZoomReducer';
import selectedDataReducer from './reducer-selectedData';
import loginStateReducer from './reducer-loginState';
import colorIndexReducer from './reducer-colorIndexReducer';

//import boxReducer from './reducer-boxReducer';


export const initialState =
  {metadata: {metadata: null, userColor: null,
              patientColor: null, siteColor: null, isolateColor: null,
              patients: null, locations: null, isolates: null,
              dateRange: null, daysRange: null},
   floorplan: null,
   //floorplanLevel: 1,
   tree: null,
   colorIndex: {type:null, color:null},
   transmission: null,
   //dateRange: null,
   loginState: true,
   //filteredSampleID: null,
   //filteredEntryID: null,
   //clickedElement: null,
   selectedData: {selectedData: null, selectedExtent: null},
   transLink:null,
   //treeZoomLevel: 1,
   layout:[{i: 'gantt', x: 0, y: 0, w: 5, h: 15, minW:4, minH:10},
           {i: 'ukulele', x: 0, y: 16, w: 12, h: 5, isResizable: false},
           {i: 'idxCol', x: 5, y: 0, w: 2, h: 15, minW:2, minH:10},
           {i: 'simulatedMap', x: 7, y: 0, w: 5, h: 15, minW:4, minH:10},
           {i: 'overlappingTable', x: 7, y: 0, w: 5, h: 15, minW:4, minH:10},
           {i: 'floorplan', x: 0, y: 16, w: 12, h: 20, minW:6, minH:15},
           {i: 'tree', x: 0, y: 16, w: 6, h: 15, minW:3, minH:10},
           {i: 'transmission', x: 6, y: 16, w: 6, h: 15, minW:4, minH:10},
           {i: 'table', x: 0, y: 36, w: 16, h: 10, minW: 12},
           {i: 'home', x: 0, y: 0, w: 12, h: 10, static:true},
           {i: 'bar', x: 0, y: 5, w: 12, h: 8, minW:4, minH:10}],
   activeChart: {'gantt': {show: false},
                  'idxCol': {show: false},
                  'ukulele': {show: false},
                  'simulatedMap': {show: false},
                  'overlappingTable': {show: false},
                  'floorplan': {show: false, levels: [2]},
                  'tree': {show: false},
                  'transmission': {show: false},
                  'table': {show: false},
                  'bar': {show: false},
                  'downloadVis': {show:false}}
 }

const rootReducer = combineReducers(
  {metadata: metadataReducer,
   tree: treeReducer,
   selectedData: selectedDataReducer,
   //simulatedMap: simulatedMapReducer,
   transmission: transmissionReducer,
   floorplan: floorplanReducer,
   //-1- floorplanLevel: floorplanLevelReducer,
   //-1- dateRange: dateRangeReducer,
   loginState: loginStateReducer,
   //-1- filteredSampleID: filteredSampleIDReducer,
   //-1- filteredEntryID: filteredEntryIDReducer,
   //clickedElement: clickedElementReducer,
   //treeZoomLevel: treeZoomLevelReducer,
   transLink: transLinkReducer,
   layout: layoutReducer,
   colorIndex: colorIndexReducer,
   activeChart: activeChartReducer},
  initialState)

export default rootReducer
//



// WEBPACK FOOTER //
// ./src/reducers/index.js